import { FormikEntityActionFieldInfoTooltip } from './FormikEntityActionTypeField.constants'

export function getFormikEntityActionTypeFieldInfo(options) {
  const optionsValues = options.map(item => item.value)

  return optionsValues.map(item => FormikEntityActionFieldInfoTooltip[item])
}
